const Data = {
  education:
    "I am a full-stack developer with a certificate from University of California, Riverside Extension in web development. Through a strong drive to learn and pursue this new found passion, I completed this intensive 6-month bootcamp in January of 2021. I have since continued to further my education by enrolling in additional online courses from various sources (e.g., stackskills.com).",
  languages: (
    <table>
      <tbody>
        <tr>
          <th>HTML</th>
          <th>CSS</th>
          <th>Javascript</th>
        </tr>
        <tr>
          <th>jQuery</th>
          <th>Node</th>
          <th>React</th>
        </tr>
        <tr>
          <th>MySQL</th>
          <th>MongoDB</th>
          <th>Handlebars</th>
        </tr>
      </tbody>
    </table>
  ),
  goals: (
    <ul>
      <li>
        Continued practice with CSS to better design websites without using CSS
        frameworks.
      </li>
      <li>Expand knowledge by learning the basics of a new coding language.</li>
      <li>
        Pursue professional certifications that will improve on or expand my
        career options <br />
        e.g., CompTIA, Cisco, AWS, etc.
      </li>
    </ul>
  ),
};

export default Data;
